import React, { useState, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import MessageIcon from "../../Assets/message.svg";
import { toast } from "react-toastify";
import { ThreeDot } from "react-loading-indicators";
import { baseUrl } from "../../Environments/environment";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import ChatScreenModal from "../Dashboard/Message/ChatScreenModal/ChatScreenModal";
import checkInI from "../../Assets/Checkin.svg";
import checkOutI from "../../Assets/Checkout.svg";
import { useSocket } from "../../Contexts/SocketContext/SocketContext";
import messageSound from "../../Assets/windows_sms.mp3";
import { apiClient } from "../../api";
import ReasonModal from "./ReasonModal";
const reverseMapStatus = {
	Reservation: "Booking",
	"In House": "In House",
	"Checked Out": "Checked Out",
	Cancelled: "Cancelled",
};
const AddonRequestModal = ({ onClose, propertyId }) => {
	const messageAudio = new Audio(messageSound);
	const [currentStatus, setCurrentStatus] = useState("Requested");
	const [selectedGuest, setSelectedGuest] = useState(null);
	const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);
	const [addons, setAddons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [propertyAddons, setPropertyAddons] = useState([]);
	const { accessToken } = useAuth();
	const { socket } = useSocket();
	const [addonLoading, setAddonLoading] = useState(null);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [filteredAddOns, setFilteredAddons] = useState([]);
	const [acceptedCount, setAcceptedCount] = useState(0);
	const [requestedCount, setRequestedCount] = useState(0);
	const [declinedCount, setDeclinedCount] = useState(0);
	const [closedCount, setClosedCount] = useState(0);
	const [completedCount, setCompletedCount] = useState(0);
	const [fetchedStatus, setFetechedStatus] = useState(false);
	const [allAddons, setAllAddons] = useState([]);
	const [selectedRequest, setSelectedRequest] = useState(null);
	const [roomTypes, setRoomTypes] = useState([]);
	const propertyNotificationSoundEnabled = localStorage.getItem("propertyNotificationSoundEnabled")==="true";
	console.log('propertyNotificationSoundEnabled',propertyNotificationSoundEnabled);


	const [options, setOptions] = useState([
		"All",
		"Housekeeping only",
		"Early CheckIn Only",
		"Late Checkout Only",
		"Upgrade Room",
	]);
	const requestTypeMap = {
		"Early CheckIn Only": "earlyCheckIn",
		"Late Checkout Only": "lateCheckOut",
		"Housekeeping only": "houseKeeping",
		"Upgrade Room": "upgradeRoom",
	};
	const [selectedOption, setSelectedOption] = useState("All");

	useEffect(() => {
		let filtered = allAddons;

		// Filter by status tab
		if (currentStatus) {
			filtered = allAddons.filter(
				(addon) => addon.requestStatus === currentStatus,
			);
		}

		// Filter by dropdown option
		if (selectedOption !== "All") {
			const requestType = requestTypeMap[selectedOption];
			if (requestType) {
				filtered = filtered.filter(
					(addon) => addon.requestType === requestType,
				);
			}
		}

		// Sort by createdAt in descending order (latest first)
		filtered = filtered.sort((a, b) => {
			const dateA = new Date(a.createdAt || 0);
			const dateB = new Date(b.createdAt || 0);
			return dateB - dateA; // Descending order (latest first)
		});

		setFilteredAddons(filtered);
	}, [currentStatus, selectedOption, allAddons]);

	const refreshAddons = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/guest/addons/${propertyId}?requestStatus=all`,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]);
				}
			}

			const allData = response.data.result.requests;

			// Automatically move requests to "Closed" when guest status is "Checked Out"
			const processedData = allData.map((addon) => {
				if (
					(addon.guestId?.status?.currentStatus === "Checked Out" &&
						addon.requestStatus === "Requested")
					|| (
						addon.guestId?.status?.currentStatus !== "Reservation"
						&& addon.requestStatus === "Requested"
						&& addon.name === "Early Check In"
					)
				) {
					// Update the request status to "Closed" automatically
					return { ...addon, requestStatus: "Closed" };
				}
				return addon;
			});

			setAllAddons(processedData);
			setPropertyAddons(response.data.result.propertyAddons);
			getRoomTypes();

			setAcceptedCount(
				processedData.filter((a) => a.requestStatus === "Accepted").length,
			);
			setRequestedCount(
				processedData.filter((a) => a.requestStatus === "Requested").length,
			);
			setDeclinedCount(
				processedData.filter((a) => a.requestStatus === "Declined").length,
			);
			setCompletedCount(
				processedData.filter((a) => a.requestStatus === "Completed").length,
			);
			setClosedCount(
				processedData.filter((a) => a.requestStatus === "Closed").length,
			);
		} catch (error) {
			console.error("Error fetching requests:", error);
			toast.error("Failed to refresh addon requests.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		refreshAddons();
		socket.on("request:update", refreshAddons);

		return () => {
			socket.off("request:update", refreshAddons);
		};
	}, [socket, propertyId]);

	const closeChatScreen = () => {
		setSelectedGuest(null);
	};
	const getInitials = (firstName, lastName) => {
		return (firstName[0] + lastName[0]).toUpperCase();
	};
	const handleStatusChange = async (guest, status) => {
		if (status === "Declined") {
			setSelectedRequest(guest);
			setIsReasonModalOpen(true);
		} else {
			const url = `${baseUrl}/checkInOutRequest/${propertyId}/${guest.guestId._id}/${guest._id}`;
			let updatedStatus = {
				requestStatus: status,
			};
			try {
				setAddonLoading(guest._id);
				const response = await apiClient.patch(url, updatedStatus);
				if (response.ok) {
					const newToken = response.headers.get("Authorization");
					if (newToken) {
						localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
					}
				}
				toast.success(`Status updated to ${status}`);
				refreshAddons(); // Refresh data to reflect changes
			} catch (error) {
				const errorMessage =
					error.response?.data?.message ||
					"Failed to update status. Please try again.";
				toast.error(errorMessage);
			} finally {
				setAddonLoading(null);
			}
		}
	};
	const handleCustomAddonStatusChange = async (guest, status) => {
		if (status === "Declined") {
			setSelectedRequest(guest);
			setIsReasonModalOpen(true);
		} else {
			const url = `${baseUrl}/addOnsRequest/${propertyId}/${guest.guestId._id}/${guest._id}`;
			let updatedStatus = {
				requestStatus: status,
			};
			try {
				setAddonLoading(guest._id);
				const response = await apiClient.put(url, updatedStatus);
				if (response.ok) {
					const newToken = response.headers.get("Authorization");
					if (newToken) {
						localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
					}
				}
				if(propertyNotificationSoundEnabled){
					messageAudio.play();
				}
				toast.success(`Status updated to ${status}`);
				refreshAddons(); // Refresh data to reflect changes
			} catch (error) {
				const errorMessage =
					error.response?.data?.message ||
					"Failed to update status. Please try again.";
				toast.error(errorMessage);
			} finally {
				setAddonLoading(null);
			}
		}
	};
	const handleCloseAddons = async (guest, request) => {
		try {
			console.log("Guest", guest);
			const url = `${baseUrl}/guest/addOns/${propertyId}/${guest._id}/${
				request._id
			}?requestType=${request.requestType ? request.requestType : "addOns"}`;
			const response = await apiClient.delete(url);
			if (response.ok) {
				toast.success("Request closed successfully.");
				refreshAddons();
			}
		} catch (e) {
			console.log(e);
			toast.error("Failed to close request.");
		}
	};
	const handleHouseKeepingStatusChange = async (guest, status) => {
		// Handle case where guestId is null for housekeeping requests
		if (!guest.guestId || !guest.guestId._id) {
			alert("Feature coming soon");
			return;
		}

		if (status === "Declined") {
			setSelectedRequest(guest);
			setIsReasonModalOpen(true);
		} else {
			const url = `${baseUrl}/guest/houseKeepingRequest/${propertyId}/${guest.guestId._id}/${guest._id}`;
			let updatedStatus = {
				requestStatus: status,
			};
			try {
				setAddonLoading(guest._id);
				const response = await apiClient.patch(url, updatedStatus);
				if (response.ok) {
					const newToken = response.headers.get("Authorization");
					if (newToken) {
						localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
					}
				}
				if(propertyNotificationSoundEnabled){
					messageAudio.play();
				}
				toast.success(`Status updated to ${status}`);
				refreshAddons();
			} catch (error) {
				const errorMessage =
					error.response?.data?.message ||
					"Failed to update status. Please try again.";
				toast.error(errorMessage);
			} finally {
				setAddonLoading(null);
			}
		}
	};

	const handleUpgradeRoomStatusChange = async (guest, status) => {
		if (status === "Rejected") {
			setSelectedRequest(guest);
			setIsReasonModalOpen(true);
		} else {
			const url = `${baseUrl}/guest/upgradeRoomRequest/${propertyId}/${guest.guestId._id}/${guest._id}`;
			let updatedStatus = {
				requestStatus: status,
			};
			try {
				setAddonLoading(guest._id);
				const response = await apiClient.patch(url, updatedStatus);
				if(propertyNotificationSoundEnabled){
					messageAudio.play();
				}
				toast.success(`Status updated to ${status}`);
				refreshAddons();
			} catch (error) {
				const errorMessage =
					error.response?.data?.message ||
					"Failed to update status. Please try again.";
				toast.error(errorMessage);
			} finally {
				setAddonLoading(null);
			}
		}
	};

	const getRoomTypes = async () => {
		try {
			const propertyId = localStorage.getItem("selectedPropertyId");
			const accessToken = localStorage.getItem("accessToken");
			const response = await apiClient.get(
				`${baseUrl}/upgradeRoomWorkflow/roomType/${propertyId}`,
				{
					headers: {
						Authorization: `Bearer ${accessToken}`,
					},
				},
			);
			if (response.status === 200) {
				console.log("Room types fetched:", response.data.result.roomType);
				setRoomTypes(response.data.result.roomType);
			}
		} catch (error) {
			console.error("Error fetching room types:", error);
		}
	};

	const getRoomTypeName = (roomId) => {
		console.log("Room types:", roomTypes);
		console.log("Room id:", roomId);
		return roomTypes.find((room) => room.id == roomId)?.roomType || undefined;
	};

	return (
		<div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
			<div className="relative bg-white rounded-lg shadow-lg p-6 w-3/4 h-[90vh] overflow-hidden">
				<button
					className="absolute top-5 right-5 text-gray-500 hover:text-gray-700"
					onClick={() => onClose(requestedCount)}
					aria-label="Close"
				>
					<AiOutlineClose className="h-5 w-5" />
				</button>

				<div className="px-4 sm:px-6 lg:px-4">
					{/* Addon Status Buttons */}
					<div className="sm:flex sm:items-center relative">
						<div className="mt-2 text-sm sm:mt-0 sm:ml-2 flex space-x-4">
							{[
								"Requested",
								"Accepted",
								"Declined",
								"Completed",
								"Unfulfilled",
							].map((status) => (
								<button
									key={status}
									onClick={() =>
										setCurrentStatus(
											status === "Unfulfilled" ? "Closed" : status,
										)
									}
									className={`px-4 py-2 rounded-md border font-semibold transition-colors ${
										currentStatus ===
										(status === "Unfulfilled" ? "Closed" : status)
											? "bg-indigo-600 text-white border-indigo-600"
											: "text-gray-700 border-gray-300"
									} hover:bg-indigo-500 hover:text-white hover:border-indigo-500`}
								>
									{status}
									{!loading &&
										(status === "Accepted"
											? ` (${acceptedCount})`
											: status === "Requested"
												? ` (${requestedCount})`
												: status === "Declined"
													? ` (${declinedCount})`
													: status === "Completed"
														? ` (${completedCount})`
														: status === "Unfulfilled"
															? ` (${closedCount})`
															: "")}
								</button>
							))}
						</div>
						{/*Here i want a dropdown but it should be aligned on right side*/}
						{/* Dropdown aligned to the right */}
						<div className="relative sm:ml-auto mr-20">
							<button
								onClick={() => setDropdownOpen(!dropdownOpen)}
								className="w-auto px-6 py-2 rounded-md border font-semibold transition-colors text-gray-700 border-gray-300 hover:bg-indigo-500 hover:text-white hover:border-indigo-500"
							>
								{selectedOption} ▼
							</button>

							{dropdownOpen && (
								<div className="absolute right-0 mt-2 w-56 bg-white border border-gray-300 rounded-md shadow-lg z-50">
									<ul className="py-2">
										{options.map((option) => (
											<li key={option}>
												<button
													className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-indigo-500 hover:text-white"
													onClick={() => (
														setDropdownOpen(false), setSelectedOption(option)
													)}
												>
													{option}
												</button>
											</li>
										))}
									</ul>
								</div>
							)}
						</div>
					</div>

					{/* Table of Filtered People */}
					<div className="mt-8 flow-root">
						<div className="-mx-4 -my-2 h-[70vh] overflow-y-auto sm:-mx-6 lg:-mx-8">
							<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
								<div className="overflow-x-auto">
									<table className="min-w-full divide-y divide-gray-300 table-fixed">
										<thead>
											<tr>
												<th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 w-1/4">
													Name
												</th>
												<th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-1/4">
													Check In/Out
												</th>
												<th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-[15%]">
													Room No
												</th>
												<th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-1/3">
													Addon
												</th>

												<th className="text-left relative py-3.5 pl-3 pr-4  text-sm font-semibold text-gray-900 w-auto">
													Action
												</th>
											</tr>
										</thead>
										<tbody className="divide-y divide-gray-200 bg-white">
											{loading
												? <>
														{[...Array(5)].map((_, index) => (
															<tr key={index} className="animate-pulse">
																<td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
																	<div className="flex items-center">
																		<div className="h-10 w-10 rounded-full bg-gray-200"></div>
																		<div className="ml-4 space-y-2">
																			<div className="h-4 w-32 rounded bg-gray-200"></div>
																			<div className="h-3 w-24 rounded bg-gray-200"></div>
																		</div>
																	</div>
																</td>
																<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
																	<div className="space-y-2">
																		<div className="h-4 w-28 rounded bg-gray-200"></div>
																		<div className="h-4 w-28 rounded bg-gray-200"></div>
																	</div>
																</td>
																<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
																	<div className="h-4 w-12 rounded bg-gray-200"></div>
																</td>
																<td className="whitespace-normal break-words px-3 py-5 text-sm text-gray-500">
																	<div className="h-10 w-full rounded bg-gray-200"></div>
																</td>
																<td className="whitespace-nowrap px-3 py-8 text-sm text-gray-500">
																	<div className="flex items-center space-x-3">
																		<div className="h-8 w-16 rounded-md bg-gray-200"></div>
																		<div className="h-8 w-16 rounded-md bg-gray-200"></div>
																		<div className="h-5 w-5 rounded-md bg-gray-200"></div>
																	</div>
																</td>
															</tr>
														))}
													</>
												: filteredAddOns &&
													filteredAddOns.length > 0 &&
													filteredAddOns.map((person) => (
														<tr key={person._id}>
															{console.log(person)}
															<td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
																<div className="flex items-center">
																	<div
																		className={`h-10 w-10 flex-shrink-0 flex items-center justify-center rounded-full ${
																			person.guestId?.status
																				?.preArrivalStatus === "Applied"
																				? "bg-green-500"
																				: "bg-[#6B7280]"
																		} text-white font-medium`}
																	>
																		{person.guestId?.status
																			?.preArrivalStatus === "Applied"
																			? <span className="text-xl">✓</span> // Check mark symbol
																			: person.guestId
																				? `${
																						person.guestId?.firstName?.[0] || ""
																					}${person.guestId?.lastName?.[0] || ""}`
																				: "--"}
																	</div>

																	<div className="ml-4">
																		<div className="flex flex-col">
																			<div className="font-medium text-gray-900">
																				{person.guestId
																					? person.guestId?.firstName +
																						" " +
																						person.guestId?.lastName
																					: "--"}
																			</div>
																			<div className="block">
																				<span className="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset text-gray-700 bg-gray-50 ring-gray-600/20">
																					{person.guestId
																						? reverseMapStatus[
																								person.guestId?.status
																									?.currentStatus
																							]
																						: "--"}
																					{person.guestId
																						?.confirmationNumber && (
																						<span className="ml-1 w-14">
																							{person.guestId
																								?.confirmationNumber?.length > 4
																								? `${person?.guestId?.confirmationNumber?.slice(
																										0,
																										4,
																									)}...`
																								: person.guestId
																										?.confirmationNumber}
																						</span>
																					)}
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>

															<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
																<div className="flex items-center space-x-2">
																	<img
																		src={checkInI}
																		alt="Check-in"
																		className="h-4 w-4"
																	/>
																	<p>
																		{person.guestId?.checkIn
																			? new Date(
																					person.guestId.checkIn,
																				).toLocaleString("en", {
																					day: "2-digit",
																					month: "2-digit",
																					hour: "2-digit",
																					minute: "2-digit",
																					hour12: true,
																					timeZone: "UTC",
																				})
																			: "--"}
																	</p>
																</div>
																<div className="flex items-center space-x-2">
																	<img
																		src={checkOutI}
																		alt="Check-out"
																		className="h-3.5 w-3.5"
																	/>
																	<p>
																		{person.guestId?.checkOut
																			? new Date(
																					person.guestId.checkOut,
																				).toLocaleString("en", {
																					day: "2-digit",
																					month: "2-digit",
																					hour: "2-digit",
																					minute: "2-digit",
																					hour12: true,
																					timeZone: "UTC",
																				})
																			: "--"}
																	</p>
																</div>
															</td>
															<td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
																{person?.guestId?.roomNumber
																	? person.guestId.roomNumber
																	: person.requestType === "houseKeeping" &&
																			person.roomNumber
																		? person.roomNumber
																		: ""}
															</td>
															<td className="whitespace-normal break-words px-3 py-5 text-sm text-gray-500">
																<span className="text-gray-900 bg-gray-100">
																	{person.requestType === "extendStay"
																		? `Extend Stay till ${new Date(
																				person.extendStayDateTime,
																			).toLocaleString("en", {
																				year: "numeric",
																				day: "2-digit",
																				month: "2-digit",
																				timeZone: "UTC",
																			})} ${
																				person?.price ? `$${person?.price}` : ""
																			}`
																		: person.requestType === "earlyCheckIn"
																			? `Early Check-in for ${new Date(
																					person.earlyCheckInDateTime,
																				).toLocaleString("en", {
																					day: "2-digit",
																					month: "2-digit",
																					hour: "2-digit",
																					minute: "2-digit",
																					hour12: true,
																					timeZone: "UTC",
																				})}
																	${
																		person?.addOnData?.price
																			? `$${person?.addOnData?.price}`
																			: ""
																	}`
																			: person.requestType === "lateCheckOut"
																				? `Late Check-out for ${new Date(
																						person.lateCheckOutDateTime,
																					).toLocaleString("en", {
																						day: "2-digit",
																						month: "2-digit",
																						hour: "2-digit",
																						minute: "2-digit",
																						hour12: true,
																						timeZone: "UTC",
																					})} ${
																						person?.addOnData?.price
																							? `$${person?.addOnData?.price}`
																							: ""
																					}`
																				: person.requestType === "houseKeeping"
																					? `Housekeeping (${
																							person.options
																								? person.options.join(", ")
																								: ""
																						})`
																					: person.requestType ===
																							"Upgrade Room"
																						? `Upgrade Room(
																						${getRoomTypeName(person?.roomType)}
																					) ${person?.price ? `$${person?.price}` : ""}`
																						: ""}
																</span>
															</td>

															<td className="whitespace-nowrap px-3 py-8 text-sm text-gray-500 flex items-center space-x-3">
																{currentStatus === "Requested"
																	? addonLoading === person._id
																		? <>
																				<p>Please wait...</p>
																			</>
																		: <>
																				{/* Disable buttons if guest status is "Checked Out" */}
																				{person.guestId?.status
																					?.currentStatus === "Checked Out" &&
																				person.guestId
																					? <button
																							className={`text-red-500 px-3 py-1 rounded-md font-medium`}
																							onClick={() =>
																								handleCloseAddons(
																									person.guestId,
																									person,
																								)
																							}
																						>
																							Close
																						</button>
																					: <>
																							<button
																								className={`text-red-500 px-3 py-1 rounded-md font-medium ${
																									person.guestId?.status
																										?.currentStatus ===
																									"Checked Out"
																										? "opacity-50 cursor-not-allowed"
																										: ""
																								}`}
																								onClick={() =>
																									person?.requestType ===
																									"extendStay"
																										? handleStatusChange(
																												person,
																												"Declined",
																											)
																										: person?.addOnData
																													?.addOnType ===
																												"CustomAddon"
																											? handleCustomAddonStatusChange(
																													person,
																													"Declined",
																												)
																											: person?.requestType ===
																													"houseKeeping"
																												? handleHouseKeepingStatusChange(
																														person,
																														"Declined",
																													)
																												: person?.requestType ===
																														"Upgrade Room"
																													? handleUpgradeRoomStatusChange(
																															person,
																															"Rejected",
																														)
																													: handleStatusChange(
																															person,
																															"Declined",
																														)
																								}
																								disabled={
																									person.guestId?.status
																										?.currentStatus ===
																									"Checked Out"
																								}
																							>
																								Deny
																							</button>
																							<button
																								className={`bg-green-500 text-white px-3 py-1 rounded-md font-medium hover:bg-green-600 ${
																									person.guestId?.status
																										?.currentStatus ===
																									"Checked Out"
																										? "opacity-50 cursor-not-allowed"
																										: ""
																								}`}
																								onClick={() =>
																									person?.addOnData
																										?.addOnType ===
																									"CustomAddon"
																										? handleCustomAddonStatusChange(
																												person,
																												"Accepted",
																											)
																										: person?.requestType ===
																												"houseKeeping"
																											? handleHouseKeepingStatusChange(
																													person,
																													"Accepted",
																												)
																											: person?.requestType ===
																													"Upgrade Room"
																												? handleUpgradeRoomStatusChange(
																														person,
																														"Accepted",
																													)
																												: handleStatusChange(
																														person,
																														"Accepted",
																													)
																								}
																								disabled={
																									person.guestId?.status
																										?.currentStatus ===
																									"Checked Out"
																								}
																							>
																								Accept
																							</button>
																						</>}
																			</>
																	: currentStatus === "Accepted"
																		? <span className="text-green-700 font-medium">
																				Accepted
																			</span>
																		: <span
																				className={`${
																					currentStatus === "Declined"
																						? "text-red-700"
																						: currentStatus === "Completed"
																							? "text-blue-700"
																							: currentStatus === "Closed"
																								? "text-gray-700"
																								: ""
																				} font-medium`}
																			>
																				{currentStatus === "Declined"
																					? "Declined"
																					: currentStatus === "Completed"
																						? "Completed"
																						: currentStatus === "Closed"
																							? "Unfulfilled"
																							: ""}
																			</span>}
																{person.guestId && (
																	<button
																		className="text-blue-600 hover:text-blue-900 text-xl"
																		onClick={(e) => {
																			e.stopPropagation();
																			setSelectedGuest(person.guestId);
																		}}
																	>
																		<img
																			src={MessageIcon}
																			alt="View"
																			className="w-5 h-5 cursor-pointer"
																		/>
																	</button>
																)}
															</td>
														</tr>
													))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{selectedGuest && (
				<ChatScreenModal
					guestId={selectedGuest._id}
					guest={selectedGuest}
					onClose={closeChatScreen}
				/>
			)}
			<ReasonModal
				isOpen={isReasonModalOpen}
				onClose={() => {
					setIsReasonModalOpen(false);
				}}
				onRejectionSuccess={() => {
					setIsReasonModalOpen(false);
					refreshAddons();
				}}
				request={selectedRequest}
				propertyNotificationSoundEnabled={propertyNotificationSoundEnabled}
			/>
		</div>
	);
};

export default AddonRequestModal;
